import { getAuth } from 'quartz-core/framework/auth/app';
import { Provider } from 'react-redux';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import { configureStore } from './utils/configureStore';
import { startApp, initializeAuth } from './actions/AppActions';
import { Routes } from './components/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const prepareApp = () => {
  const store = configureStore();
  store.dispatch(initializeAuth(getAuth()));
  store.dispatch(startApp());
  return {
    props: {
      store
    }
  };
};
export function AppComponent({
  store
}) {
  return /*#__PURE__*/_jsxs(Provider, {
    store: store,
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(Routes, {})]
  });
}